import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/axiosAuth";

export const fetchUsers = createAsyncThunk("users/fetchUsers", async () => {
  const response = await api.get("/api/users/list");
  return response.data;
});

const usersSlice = createSlice({
  name: "users",
  initialState: {
    rows: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default usersSlice.reducer;

export const selectUsersStatus = (state) => state.users.status;
export const selectUsersRows = (state) => state.users.rows;
